import { Fragment, useEffect, useState } from "react";
import "./Home.css";
import { useNavigate, useParams } from "react-router-dom";
import Singleproductslice from "../store/Singleproductslice";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import Loader from "./Loader";
import Singleproduct from "./Singleproduct";




const Search = () => {

    const loader = useSelector((store) => {
        return store.singleproduct.loading

    })

    const singleproductvalue = useSelector((store) => {
        return store.singleproduct.singleproduct

    })
    const [svalue, setsvalue] = useState([]);
    const dispatch = useDispatch();
    const { keywordvalue } = useParams();

    useEffect(() => {
        dispatch(Singleproductslice.actions.singleproductrequest())
        axios.get("https://retoolapi.dev/BUQ2aS/allcomponents/")
            .then(response => dispatch(Singleproductslice.actions.singleproductsuccess(response.data)))
            .catch(err => alert("Product not found"))


    }, []);
    useEffect(() => {
        setsvalue(singleproductvalue.filter(f => f.title.toLowerCase().includes(keywordvalue)))
        console.log(svalue)

    }, [svalue])
    return (
        <Fragment>


            {loader ? <Loader> </Loader> :


                <div className="frames">

                    {svalue.map((ele, idx) => {
                        return (
                            <Singleproduct id={ele.id} img={ele.img} num={ele.num} title={ele.title} desc={ele.desc} price={ele.price} ></Singleproduct>
                        )
                    })}
                </div>
            }



        </Fragment>



    )
}
export default Search;